/**
 * HTTP seviyesi permission interceptor yapılandırması.
 * Kurallar: src/app/config/endpoint-permission.rules.ts
 * Referans: src/app/config/api-permission-map.md
 */
export const ENDPOINT_PERMISSION_INTERCEPTOR_ENABLED = true;

/** Map'te eşleşmeyen istekleri console'a yaz (geliştirme) */
export const ENDPOINT_PERMISSION_LOG_UNMATCHED = false;

/** Engellenen istekleri console'a yaz (geliştirme) */
export const ENDPOINT_PERMISSION_LOG_DENIED = true;
